'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const Header = () => {
  const translate = useTranslate('business.pro_integrations_application.header')

  return (
    <div
      className="content-block__heading u-ui-padding-vertical-x4-large@desktops u-ui-padding-vertical-x3-large@portables pro-integrations-application_form-header"
      data-test-id="pro-integrations-application-form-header"
    >
      <h1 className="pro-integrations-application_form-header-title">{translate('title')}</h1>
      <p className="pro-integrations-application_form-header-description">
        {translate('description')}
      </p>
    </div>
  )
}

export default Header
